module.exports = __webpack_public_path__ + "img/Nirman-Logo-new.12f05d59.jpg";